module.exports = __webpack_public_path__ + "img/20191031163421360截图20191031152319065.d7eeacf9.jpg";